var path = 'templates/editing_list.html';
var html = " <div class=\"entries md-whiteframe-2dp md-padding\" style=width:280px;height:300px;display:inline-block;margin:5px ng-repeat=\"e in editingList\" ng-init=\"book = Books.get(e.bookId)\"> <a ui-sref=\"transcription.content.input({id: e.bookId, content: e.content+1})\" class=title>{{book.title}}-コマ{{e.content+1}} <div class=thumbnail> <img ng-if=book.images ng-src=./resources/img/thumbnails/{{e.bookId}}.min.jpg> <img ng-if=!book.images ng-src=./resources/img/noimage.png /> </div> </a> <p>{{moment(event.timestamp).fromNow()}}に編集</p> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/templates/editing_list.html
// module id = 18
// module chunks = 0